"use client";

import { Toaster } from "react-hot-toast";

export default function ToastProvider() {
  return (
    <Toaster
      position="top-right"
      toastOptions={{
        duration: 3000,
        style: {
          background: "#1f2937", // Tailwind gray-800
          color: "#fff",
          borderRadius: "8px",
          padding: "12px 16px",
          fontSize: "14px",
        },
        success: {
          iconTheme: {
            primary: "#4ade80", // Tailwind green-400
            secondary: "#1f2937",
          },
        },
        error: {
          iconTheme: {
            primary: "#f87171", // Tailwind red-400
            secondary: "#1f2937",
          },
        },
      }}
    />
  );
}
